/**
 * @typedef {"text/h323" | "application/x-trash" | "application/x-trash" 
 * | "video/3gpp" | "application/x-7z-compressed" | "application/x-abiword" 
 * | "application/postscript" | "audio/x-aiff" | "audio/x-aiff" 
 * | "audio/x-aiff" | "chemical/x-alchemy" | "audio/amr" 
 * | "application/annodex" | "application/vnd.android.package-archive" 
 * | "image/x-jg" | "text/plain" | "video/x-ms-asf" | "video/x-ms-asf" 
 * | "chemical/x-ncbi-asn1" | "application/atom+xml" | "application/atomcat+xml" 
 * | "application/atomserv+xml" | "audio/basic" | "audio/basic" 
 * | "video/x-msvideo" | "audio/amr-wb" | "audio/annodex" | "video/annodex" 
 * | "chemical/x-molconn-Z" | "application/x-trash" | "application/x-msdos-program" 
 * | "application/x-bcpio" | "text/x-bibtex" | "application/octet-stream" 
 * | "image/x-ms-bmp" | "text/x-boo" | "application/x-maker" | "text/plain" 
 * | "chemical/x-crossfire" | "text/x-csrc" | "text/x-c++src" | "chemical/x-chem3d" 
 * | "application/x-cab" | "chemical/x-cache" | "chemical/x-cache" 
 * | "application/cap" | "chemical/x-cactvs-binary" 
 * | "application/vnd.ms-pki.seccat" | "chemical/x-cactvs-binary" 
 * | "application/x-cbr" | "application/x-cbz" | "text/x-c++src" 
 * | "application/x-cdf" | "application/x-cdf" | "image/x-coreldraw" 
 * | "image/x-coreldrawtemplate" | "chemical/x-cdx" | "application/vnd.cinderella" 
 * | "chemical/x-cerius" | "chemical/x-chemdraw" | "application/x-kchart" 
 * | "chemical/x-cif" | "application/java-vm" | "text/x-tex" | "chemical/x-cmdf" 
 * | "chemical/x-cml" | "application/vnd.rim.cod" | "application/x-msdos-program" 
 * | "chemical/x-compass" | "application/x-cpio" | "text/x-c++src" 
 * | "image/x-corelphotopaint" | "image/x-canon-cr2" | "application/x-pkcs7-crl" 
 * | "application/x-x509-ca-cert" | "image/x-canon-crw" | "audio/csound" 
 * | "chemical/x-cache-csf" | "application/x-csh" | "chemical/x-csml" 
 * | "chemical/x-csml" | "text/css" | "text/csv" | "chemical/x-cactvs-binary" 
 * | "chemical/x-ctx" | "application/cu-seeme" | "chemical/x-gaussian-cube" 
 * | "chemical/x-cxf" | "chemical/x-cxf" | "text/x-c++src" | "text/x-dsrc" 
 * | "application/x-ns-proxy-autoconfig" | "application/davmount+xml" 
 * | "application/x-director" | "application/x-debian-package" | "video/dv" 
 * | "video/dv" | "text/x-diff" | "text/x-diff" | "application/x-director" 
 * | "image/vnd.djvu" | "image/vnd.djvu" | "video/dl" 
 * | "application/x-msdos-program" | "application/x-apple-diskimage" 
 * | "application/x-dms" | "application/msword" 
 * | "application/vnd.ms-word.document.macroEnabled.12" 
 * | "application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
 * | "application/msword" | "application/vnd.ms-word.template.macroEnabled.12" 
 * | "application/vnd.openxmlformats-officedocument.wordprocessingml.template" 
 * | "application/x-dvi" | "application/x-director" 
 * | "chemical/x-embl-dl-nucleotide" | "chemical/x-embl-dl-nucleotide" 
 * | "message/rfc822" | "application/postscript" | "application/postscript" 
 * | "application/postscript" | "application/postscript" | "application/postscript" 
 * | "image/x-epson-erf" | "application/ecmascript" | "text/x-setext" 
 * | "application/x-msdos-program" | "application/andrew-inset" 
 * | "application/x-maker" | "application/x-maker" 
 * | "chemical/x-gaussian-checkpoint" | "chemical/x-gaussian-checkpoint" 
 * | "application/x-xfig" | "audio/flac" | "video/fli" | "video/x-flv" 
 * | "application/x-maker" | "application/x-maker" | "application/x-maker" 
 * | "chemical/x-gaussian-log" | "chemical/x-gamess-input" 
 * | "chemical/x-gamess-input" | "application/x-ganttproject" 
 * | "chemical/x-gaussian-input" | "text/x-pcs-gcd" 
 * | "application/x-graphing-calculator" | "chemical/x-gcg8-sequence" 
 * | "chemical/x-genbank" | "application/x-tex-gf" | "image/gif" 
 * | "chemical/x-gaussian-input" | "chemical/x-gaussian-input" 
 * | "video/gl" | "application/x-gnumeric" | "chemical/x-mopac-graph" 
 * | "application/x-font" | "audio/x-gsm" | "application/x-gtar" 
 * | "text/x-chdr" | "text/x-c++hdr" | "application/x-hdf" | "text/x-c++hdr" 
 * | "chemical/x-hin" | "text/x-c++hdr" | "application/mac-binhex40" 
 * | "text/x-haskell" | "application/hta" | "text/x-component" | "text/html" 
 * | "text/html" | "text/x-c++hdr" | "application/x-ica" 
 * | "x-conference/x-cooltalk" | "image/x-icon" | "text/calendar" 
 * | "text/calendar" | "image/ief" | "model/iges" | "model/iges" 
 * | "application/x-iphone" | "application/x-info" | "chemical/x-gamess-input" 
 * | "application/x-internet-signup" | "application/x-iso9660-image" 
 * | "application/x-internet-signup" | "chemical/x-isostar" | "chemical/x-isostar" 
 * | "text/vnd.sun.j2me.app-descriptor" | "application/x-jam" 
 * | "application/java-archive" | "text/x-java" | "chemical/x-jcamp-dx" 
 * | "chemical/x-jcamp-dx" | "application/x-jmol" | "image/x-jng" 
 * | "application/x-java-jnlp-file" | "image/jpeg" | "image/jpeg" | "image/jpeg" 
 * | "application/javascript" | "application/json" | "audio/midi" 
 * | "application/pgp-keys" | "application/x-killustrator" | "chemical/x-kinemage" 
 * | "application/vnd.google-earth.kml+xml" | "application/vnd.google-earth.kmz" 
 * | "application/x-kpresenter" | "application/x-kpresenter" 
 * | "application/x-kspread" | "application/x-kword" | "application/x-kword" 
 * | "application/x-latex" | "application/x-lha" | "text/x-literate-haskell" 
 * | "application/bbolin" | "video/x-la-asf" | "video/x-la-asf" | "text/x-tex" 
 * | "application/x-lyx" | "application/x-lzh" | "application/x-lzx" 
 * | "application/m3g" | "audio/mpegurl" | "application/x-mpegURL" | "audio/mpeg" 
 * | "application/x-maker" | "application/x-troff-man" | "text/cache-manifest" 
 * | "chemical/x-mmcif" | "chemical/x-macmolecule" | "application/msaccess" 
 * | "application/x-troff-me" | "model/mesh" | "audio/midi" | "audio/midi" 
 * | "application/x-mif" | "application/x-freemind" | "chemical/x-macromodel-input" 
 * | "chemical/x-macromodel-input" | "application/vnd.smaf" | "text/mathml" 
 * | "video/x-mng" | "text/x-moc" | "chemical/x-mdl-molfile" | "chemical/x-mol2" 
 * | "chemical/x-mopac-out" | "chemical/x-mopac-input" | "chemical/x-mopac-input" 
 * | "video/x-sgi-movie" | "audio/mpeg" | "audio/mpeg" | "video/mp4" 
 * | "chemical/x-mopac-input" | "video/mpeg" | "video/mpeg" | "audio/mpeg" 
 * | "video/mpeg" | "audio/mpeg" | "application/x-comsol" | "video/x-matroska" 
 * | "video/x-matroska" | "application/x-troff-ms" | "model/mesh" 
 * | "application/x-msi" | "chemical/x-mopac-vib" | "application/mxf" 
 * | "video/vnd.mpegurl" | "application/mathematica" | "application/mathematica" 
 * | "application/x-netcdf" | "image/x-nikon-nef" | "application/x-nwc" 
 * | "application/x-object" | "application/oda" 
 * | "application/vnd.oasis.opendocument.database" 
 * | "application/vnd.oasis.opendocument.chart" 
 * | "application/vnd.oasis.opendocument.formula" 
 * | "application/vnd.oasis.opendocument.graphics" 
 * | "application/vnd.oasis.opendocument.image" 
 * | "application/vnd.oasis.opendocument.text-master" 
 * | "application/vnd.oasis.opendocument.presentation" 
 * | "application/vnd.oasis.opendocument.spreadsheet" 
 * | "application/vnd.oasis.opendocument.text" | "audio/ogg" | "audio/ogg" 
 * | "video/ogg" | "application/ogg" | "application/x-trash" 
 * | "application/onenote" | "application/onenote" | "application/onenote" 
 * | "application/onenote" | "audio/csound" | "image/x-olympus-orf" 
 * | "application/vnd.oasis.opendocument.graphics-template" 
 * | "application/vnd.oasis.opendocument.text-web" 
 * | "application/vnd.oasis.opendocument.presentation-template" 
 * | "application/vnd.oasis.opendocument.spreadsheet-template" 
 * | "application/vnd.oasis.opendocument.text-template" 
 * | "application/x-oz-application" | "text/x-pascal" | "text/x-pascal" 
 * | "application/x-pkcs7-certreqresp" | "application/x-ns-proxy-autoconfig" 
 * | "image/x-coreldrawpattern" | "image/x-portable-bitmap" | "application/cap" 
 * | "application/x-font" | "image/pcx" | "chemical/x-pdb" | "chemical/x-pdb" 
 * | "application/pdf" | "application/x-font" | "application/x-font" 
 * | "image/x-portable-graymap" | "application/x-chess-pgn" 
 * | "application/pgp-signature" | "application/x-httpd-php" 
 * | "application/x-httpd-php3" | "application/x-httpd-php3-preprocessed" 
 * | "application/x-httpd-php4" | "application/x-httpd-php5" 
 * | "application/x-httpd-php-source" | "application/x-httpd-php" 
 * | "application/x-httpd-php" | "application/x-tex-pk" | "text/x-perl" 
 * | "text/x-perl" | "audio/x-scpls" | "image/png" | "image/x-portable-anymap" 
 * | "text/plain" | "application/vnd.ms-powerpoint.template.macroEnabled.12" 
 * | "application/vnd.openxmlformats-officedocument.presentationml.template" 
 * | "application/vnd.ms-powerpoint.addin.macroEnabled.12" 
 * | "image/x-portable-pixmap" | "application/vnd.ms-powerpoint" 
 * | "application/vnd.ms-powerpoint.slideshow.macroEnabled.12" 
 * | "application/vnd.openxmlformats-officedocument.presentationml.slideshow" 
 * | "application/vnd.ms-powerpoint" 
 * | "application/vnd.ms-powerpoint.presentation.macroEnabled.12" 
 * | "application/vnd.openxmlformats-officedocument.presentationml.presentation" 
 * | "application/pics-rules" | "chemical/x-ncbi-asn1-ascii" 
 * | "application/postscript" | "image/x-photoshop" | "text/x-python" 
 * | "application/x-python-code" | "application/x-python-code" 
 * | "application/x-qgis" | "video/quicktime" | "video/quicktime" 
 * | "application/x-quicktimeplayer" | "audio/x-realaudio" | "audio/x-pn-realaudio" 
 * | "application/rar" | "image/x-cmu-raster" | "application/x-ruby" 
 * | "chemical/x-mdl-rdfile" | "application/rdf+xml" | "application/x-rdp" 
 * | "image/x-rgb" | "application/x-httpd-eruby" | "audio/x-pn-realaudio" 
 * | "application/x-troff" | "chemical/x-rosdal" 
 * | "application/x-redhat-package-manager" | "application/rss+xml" 
 * | "application/rtf" | "text/richtext" | "chemical/x-mdl-rxnfile" 
 * | "text/x-scala" | "application/x-scilab" | "application/x-scilab" 
 * | "audio/csound" | "application/x-silverlight" | "text/scriptlet" 
 * | "text/scriptlet" | "chemical/x-mdl-sdfile" | "chemical/x-mdl-sdfile" 
 * | "audio/x-sd2" | "application/vnd.stardivision.draw" 
 * | "application/vnd.stardivision.calc" | "application/vnd.stardivision.impress" 
 * | "application/vnd.stardivision.chart" | "application/vnd.stardivision.writer" 
 * | "application/java-serialized-object" | "text/x-sfv" | "application/x-go-sgf" 
 * | "application/vnd.stardivision.writer-global" | "application/x-sh" 
 * | "application/x-shar" | "application/x-qgis" | "text/html" 
 * | "application/x-qgis" | "audio/prs.sid" | "application/x-trash" 
 * | "model/mesh" | "application/vnd.symbian.install" | "x-epoc/x-sisx-app" 
 * | "application/x-stuffit" | "application/x-stuffit" | "application/x-koan" 
 * | "application/x-koan" | "application/x-koan" | "application/x-koan" 
 * | "application/vnd.ms-powerpoint.slide.macroEnabled.12" 
 * | "application/vnd.openxmlformats-officedocument.presentationml.slide" 
 * | "application/smil" | "application/smil" | "chemical/x-galactic-spc" 
 * | "application/futuresplash" | "audio/ogg" | "application/x-sql" 
 * | "application/x-wais-source" | "application/vnd.sun.xml.calc.template" 
 * | "application/vnd.sun.xml.draw.template" 
 * | "application/vnd.sun.xml.impress.template" | "application/sla" 
 * | "application/vnd.sun.xml.writer.template" | "text/x-tex" 
 * | "application/x-sv4cpio" | "application/x-sv4crc" | "image/svg+xml" 
 * | "image/svg+xml" | "chemical/x-swissprot" | "application/x-shockwave-flash" 
 * | "application/x-shockwave-flash" | "application/vnd.sun.xml.calc" 
 * | "application/vnd.sun.xml.draw" | "application/vnd.sun.xml.writer.global" 
 * | "application/vnd.sun.xml.impress" | "application/vnd.sun.xml.math" 
 * | "application/vnd.sun.xml.writer" | "application/x-troff" | "application/x-tar" 
 * | "application/x-gtar-compressed" | "application/x-tcl" | "text/x-tcl" 
 * | "text/x-tex" | "application/x-texinfo" | "application/x-texinfo" 
 * | "text/plain" | "chemical/x-mdl-tgf" | "application/x-gtar-compressed" 
 * | "application/vnd.ms-officetheme" | "image/tiff" | "image/tiff" 
 * | "text/texmacs" | "application/x-bittorrent" | "application/x-troff" 
 * | "video/MP2T" | "application/dsptype" | "text/tab-separated-values" 
 * | "text/plain" | "application/x-debian-package" | "text/iuls" 
 * | "application/x-ustar" | "chemical/x-ncbi-asn1-binary" 
 * | "chemical/x-ncbi-asn1-binary" | "application/x-cdlink" | "text/x-vcard" 
 * | "text/x-vcalendar" | "chemical/x-vmd" | "chemical/x-vamas-iso14976" 
 * | "x-world/x-vrml" | "application/vnd.visio" | "application/x-doom" 
 * | "audio/x-wav" | "audio/x-ms-wax" | "image/vnd.wap.wbmp" 
 * | "application/vnd.wap.wbxml" | "video/webm" | "application/x-123" 
 * | "video/x-ms-wm" | "audio/x-ms-wma" | "application/x-ms-wmd" 
 * | "text/vnd.wap.wml" | "application/vnd.wap.wmlc" | "text/vnd.wap.wmlscript" 
 * | "application/vnd.wap.wmlscriptc" | "video/x-ms-wmv" | "video/x-ms-wmx" 
 * | "application/x-ms-wmz" | "application/vnd.wordperfect5.1" 
 * | "application/vnd.wordperfect" | "model/vrml" | "model/vrml" 
 * | "video/x-ms-wvx" | "application/x-wingz" | "model/x3d+xml" 
 * | "model/x3d+binary" | "model/x3d+vrml" | "image/x-xbitmap" 
 * | "application/x-xcf" | "application/xhtml+xml" | "application/xhtml+xml" 
 * | "application/vnd.ms-excel.addin.macroEnabled.12" | "application/vnd.ms-excel" 
 * | "application/vnd.ms-excel" 
 * | "application/vnd.ms-excel.sheet.binary.macroEnabled.12" 
 * | "application/vnd.ms-excel.sheet.macroEnabled.12" 
 * | "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
 * | "application/vnd.ms-excel" 
 * | "application/vnd.ms-excel.template.macroEnabled.12" 
 * | "application/vnd.openxmlformats-officedocument.spreadsheetml.template" 
 * | "application/xml" | "application/x-xpinstall" | "image/x-xpixmap" 
 * | "application/xml" | "application/xml" | "application/xspf+xml" 
 * | "chemical/x-xtel" | "application/vnd.mozilla.xul+xml" 
 * | "image/x-xwindowdump" | "chemical/x-xyz" | "application/zip" 
 * | "chemical/x-mopac-input"} mimeType
 * 
 * @typedef {"323" | "%" | "~" | "3gp" | "7z" | "abw" | "ai" | "aif" | "aifc" 
 * | "aiff" | "alc" | "amr" | "anx" | "apk" | "art" | "asc" | "asf" | "asx" 
 * | "asn" | "atom" | "atomcat" | "atomsrv" | "au" | "snd" | "avi" | "awb" 
 * | "axa" | "axv" | "b" | "bak" | "bat" | "bcpio" | "bib" | "bin" | "bmp" 
 * | "boo" | "book" | "brf" | "bsd" | "c" | "c++" | "c3d" | "cab" | "cac" 
 * | "cache" | "cap" | "cascii" | "cat" | "cbin" | "cbr" | "cbz" | "cc" | "cda" 
 * | "cdf" | "cdr" | "cdt" | "cdx" | "cdy" | "cer" | "chm" | "chrt" | "cif" 
 * | "class" | "cls" | "cmdf" | "cml" | "cod" | "com" | "cpa" | "cpio" | "cpp" 
 * | "cpt" | "cr2" | "crl" | "crt" | "crw" | "csd" | "csf" | "csh" | "csml" 
 * | "csm" | "css" | "csv" | "ctab" | "ctx" | "cu" | "cub" | "cxf" | "cef" 
 * | "cxx" | "d" | "dat" | "davmount" | "dcr" | "deb" | "dif" | "dv" | "diff" 
 * | "patch" | "dir" | "djvu" | "djv" | "dl" | "dll" | "dmg" | "dms" | "doc" 
 * | "docm" | "docx" | "dot" | "dotm" | "dotx" | "dvi" | "dxr" | "emb" | "embl" 
 * | "eml" | "eps" | "eps2" | "eps3" | "epsf" | "epsi" | "erf" | "es" | "etx" 
 * | "exe" | "ez" | "fb" | "fbdoc" | "fch" | "fchk" | "fig" | "flac" | "fli" 
 * | "flv" | "fm" | "frame" | "frm" | "gal" | "gam" | "gamin" | "gan" | "gau" 
 * | "gcd" | "gcf" | "gcg" | "gen" | "gf" | "gif" | "gjc" | "gjf" | "gl" 
 * | "gnumeric" | "gpt" | "gsf" | "gsm" | "gtar" | "h" | "h++" | "hdf" | "hh" 
 * | "hin" | "hpp" | "hqx" | "hs" | "hta" | "htc" | "htm" | "html" | "hxx" 
 * | "ica" | "ice" | "ico" | "ics" | "icz" | "ief" | "igs" | "iges" | "iii" 
 * | "info" | "inp" | "ins" | "iso" | "isp" | "istr" | "ist" | "jad" | "jam" 
 * | "jar" | "java" | "jdx" | "dx" | "jmz" | "jng" | "jnlp" | "jpe" | "jpeg" 
 * | "jpg" | "js" | "json" | "kar" | "key" | "kil" | "kin" | "kml" | "kmz" 
 * | "kpr" | "kpt" | "ksp" | "kwd" | "kwt" | "latex" | "lha" | "lhs" | "lin" 
 * | "lsf" | "lsx" | "ltx" | "lyx" | "lzh" | "lzx" | "m3g" | "m3u" | "m3u8" 
 * | "m4a" | "maker" | "man" | "manifest" | "mcif" | "mcm" | "mdb" | "me" 
 * | "mesh" | "mid" | "midi" | "mif" | "mm" | "mmd" | "mmod" | "mmf" | "mml" 
 * | "mng" | "moc" | "mol" | "mol2" | "moo" | "mop" | "mopcrt" | "movie" | "mp2" 
 * | "mp3" | "mp4" | "mpc" | "mpe" | "mpeg" | "mpega" | "mpg" | "mpga" | "mph" 
 * | "mpv" | "mkv" | "ms" | "msh" | "msi" | "mvb" | "mxf" | "mxu" | "nb" | "nbp" 
 * | "nc" | "nef" | "nwc" | "o" | "oda" | "odb" | "odc" | "odf" | "odg" | "odi" 
 * | "odm" | "odp" | "ods" | "odt" | "oga" | "ogg" | "ogv" | "ogx" | "old" 
 * | "one" | "onepkg" | "onetmp" | "onetoc2" | "orc" | "orf" | "otg" | "oth" 
 * | "otp" | "ots" | "ott" | "oza" | "p" | "pas" | "p7r" | "pac" | "pat" 
 * | "pbm" | "pcap" | "pcf" | "pcx" | "pdb" | "ent" | "pdf" | "pfa" | "pfb" 
 * | "pgm" | "pgn" | "pgp" | "php" | "php3" | "php3p" | "php4" | "php5" | "phps" 
 * | "pht" | "phtml" | "pk" | "pl" | "pm" | "pls" | "png" | "pnm" | "pot" 
 * | "potm" | "potx" | "ppam" | "ppm" | "pps" | "ppsm" | "ppsx" | "ppt" | "pptm" 
 * | "pptx" | "prf" | "prt" | "ps" | "psd" | "py" | "pyc" | "pyo" | "qgs" | "qt" 
 * | "mov" | "qtl" | "ra" | "ram" | "rar" | "ras" | "rb" | "rd" | "rdf" | "rdp" 
 * | "rgb" | "rhtml" | "rm" | "roff" | "ros" | "rpm" | "rss" | "rtf" | "rtx" 
 * | "rxn" | "scala" | "sci" | "sce" | "sco" | "scr" | "sct" | "wsc" | "sd" 
 * | "sdf" | "sd2" | "sda" | "sdc" | "sdd" | "sds" | "sdw" | "ser" | "sfv" 
 * | "sgf" | "sgl" | "sh" | "shar" | "shp" | "shtml" | "shx" | "sid" | "sik" 
 * | "silo" | "sis" | "sisx" | "sit" | "sitx" | "skd" | "skm" | "skp" | "skt" 
 * | "sldm" | "sldx" | "smi" | "smil" | "spc" | "spl" | "spx" | "sql" | "src" 
 * | "stc" | "std" | "sti" | "stl" | "stw" | "sty" | "sv4cpio" | "sv4crc" | "svg" 
 * | "svgz" | "sw" | "swf" | "swfl" | "sxc" | "sxd" | "sxg" | "sxi" | "sxm" 
 * | "sxw" | "t" | "tar" | "taz" | "tcl" | "tk" | "tex" | "texinfo" | "texi" 
 * | "text" | "tgf" | "tgz" | "thmx" | "tiff" | "tif" | "tm" | "torrent" | "tr" 
 * | "ts" | "tsp" | "tsv" | "txt" | "udeb" | "uls" | "ustar" | "val" | "aso" 
 * | "vcd" | "vcf" | "vcs" | "vmd" | "vms" | "vrm" | "vsd" | "wad" | "wav" 
 * | "wax" | "wbmp" | "wbxml" | "webm" | "wk" | "wm" | "wma" | "wmd" | "wml" 
 * | "wmlc" | "wmls" | "wmlsc" | "wmv" | "wmx" | "wmz" | "wp5" | "wpd" | "wrl" 
 * | "vrml" | "wvx" | "wz" | "x3d" | "x3db" | "x3dv" | "xbm" | "xcf" | "xht" 
 * | "xhtml" | "xlam" | "xlb" | "xls" | "xlsb" | "xlsm" | "xlsx" | "xlt" 
 * | "xltm" | "xltx" | "xml" | "xpi" | "xpm" | "xsd" | "xsl" | "xspf" | "xtel" 
 * | "xul" | "xwd" | "xyz" | "zip" | "zmt"} ext
 */

class MimeTypeX {

  static __extList = {
    "323": "text/h323",
    "%": "application/x-trash",
    "~": "application/x-trash",
    "3gp": "video/3gpp",
    "7z": "application/x-7z-compressed",
    "abw": "application/x-abiword",
    "ai": "application/postscript",
    "aif": "audio/x-aiff",
    "aifc": "audio/x-aiff",
    "aiff": "audio/x-aiff",
    "alc": "chemical/x-alchemy",
    "amr": "audio/amr",
    "anx": "application/annodex",
    "apk": "application/vnd.android.package-archive",
    "art": "image/x-jg",
    "asc": "text/plain",
    "asf": "video/x-ms-asf",
    "asx": "video/x-ms-asf",
    "asn": "chemical/x-ncbi-asn1",
    "atom": "application/atom+xml",
    "atomcat": "application/atomcat+xml",
    "atomsrv": "application/atomserv+xml",
    "au": "audio/basic",
    "snd": "audio/basic",
    "avi": "video/x-msvideo",
    "awb": "audio/amr-wb",
    "axa": "audio/annodex",
    "axv": "video/annodex",
    "b": "chemical/x-molconn-Z",
    "bak": "application/x-trash",
    "bat": "application/x-msdos-program",
    "bcpio": "application/x-bcpio",
    "bib": "text/x-bibtex",
    "bin": "application/octet-stream",
    "bmp": "image/x-ms-bmp",
    "boo": "text/x-boo",
    "book": "application/x-maker",
    "brf": "text/plain",
    "bsd": "chemical/x-crossfire",
    "c": "text/x-csrc",
    "c++": "text/x-c++src",
    "c3d": "chemical/x-chem3d",
    "cab": "application/x-cab",
    "cac": "chemical/x-cache",
    "cache": "chemical/x-cache",
    "cap": "application/cap",
    "cascii": "chemical/x-cactvs-binary",
    "cat": "application/vnd.ms-pki.seccat",
    "cbin": "chemical/x-cactvs-binary",
    "cbr": "application/x-cbr",
    "cbz": "application/x-cbz",
    "cc": "text/x-c++src",
    "cda": "application/x-cdf",
    "cdf": "application/x-cdf",
    "cdr": "image/x-coreldraw",
    "cdt": "image/x-coreldrawtemplate",
    "cdx": "chemical/x-cdx",
    "cdy": "application/vnd.cinderella",
    "cer": "chemical/x-cerius",
    "chm": "chemical/x-chemdraw",
    "chrt": "application/x-kchart",
    "cif": "chemical/x-cif",
    "class": "application/java-vm",
    "cls": "text/x-tex",
    "cmdf": "chemical/x-cmdf",
    "cml": "chemical/x-cml",
    "cod": "application/vnd.rim.cod",
    "com": "application/x-msdos-program",
    "cpa": "chemical/x-compass",
    "cpio": "application/x-cpio",
    "cpp": "text/x-c++src",
    "cpt": "image/x-corelphotopaint",
    "cr2": "image/x-canon-cr2",
    "crl": "application/x-pkcs7-crl",
    "crt": "application/x-x509-ca-cert",
    "crw": "image/x-canon-crw",
    "csd": "audio/csound",
    "csf": "chemical/x-cache-csf",
    "csh": "application/x-csh",
    "csml": "chemical/x-csml",
    "csm": "chemical/x-csml",
    "css": "text/css",
    "csv": "text/csv",
    "ctab": "chemical/x-cactvs-binary",
    "ctx": "chemical/x-ctx",
    "cu": "application/cu-seeme",
    "cub": "chemical/x-gaussian-cube",
    "cxf": "chemical/x-cxf",
    "cef": "chemical/x-cxf",
    "cxx": "text/x-c++src",
    "d": "text/x-dsrc",
    "dat": "application/x-ns-proxy-autoconfig",
    "davmount": "application/davmount+xml",
    "dcr": "application/x-director",
    "deb": "application/x-debian-package",
    "dif": "video/dv",
    "dv": "video/dv",
    "diff": "text/x-diff",
    "patch": "text/x-diff",
    "dir": "application/x-director",
    "djvu": "image/vnd.djvu",
    "djv": "image/vnd.djvu",
    "dl": "video/dl",
    "dll": "application/x-msdos-program",
    "dmg": "application/x-apple-diskimage",
    "dms": "application/x-dms",
    "doc": "application/msword",
    "docm": "application/vnd.ms-word.document.macroEnabled.12",
    "docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "dot": "application/msword",
    "dotm": "application/vnd.ms-word.template.macroEnabled.12",
    "dotx": "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
    "dvi": "application/x-dvi",
    "dxr": "application/x-director",
    "emb": "chemical/x-embl-dl-nucleotide",
    "embl": "chemical/x-embl-dl-nucleotide",
    "eml": "message/rfc822",
    "eps": "application/postscript",
    "eps2": "application/postscript",
    "eps3": "application/postscript",
    "epsf": "application/postscript",
    "epsi": "application/postscript",
    "erf": "image/x-epson-erf",
    "es": "application/ecmascript",
    "etx": "text/x-setext",
    "exe": "application/x-msdos-program",
    "ez": "application/andrew-inset",
    "fb": "application/x-maker",
    "fbdoc": "application/x-maker",
    "fch": "chemical/x-gaussian-checkpoint",
    "fchk": "chemical/x-gaussian-checkpoint",
    "fig": "application/x-xfig",
    "flac": "audio/flac",
    "fli": "video/fli",
    "flv": "video/x-flv",
    "fm": "application/x-maker",
    "frame": "application/x-maker",
    "frm": "application/x-maker",
    "gal": "chemical/x-gaussian-log",
    "gam": "chemical/x-gamess-input",
    "gamin": "chemical/x-gamess-input",
    "gan": "application/x-ganttproject",
    "gau": "chemical/x-gaussian-input",
    "gcd": "text/x-pcs-gcd",
    "gcf": "application/x-graphing-calculator",
    "gcg": "chemical/x-gcg8-sequence",
    "gen": "chemical/x-genbank",
    "gf": "application/x-tex-gf",
    "gif": "image/gif",
    "gjc": "chemical/x-gaussian-input",
    "gjf": "chemical/x-gaussian-input",
    "gl": "video/gl",
    "gnumeric": "application/x-gnumeric",
    "gpt": "chemical/x-mopac-graph",
    "gsf": "application/x-font",
    "gsm": "audio/x-gsm",
    "gtar": "application/x-gtar",
    "h": "text/x-chdr",
    "h++": "text/x-c++hdr",
    "hdf": "application/x-hdf",
    "hh": "text/x-c++hdr",
    "hin": "chemical/x-hin",
    "hpp": "text/x-c++hdr",
    "hqx": "application/mac-binhex40",
    "hs": "text/x-haskell",
    "hta": "application/hta",
    "htc": "text/x-component",
    "htm": "text/html",
    "html": "text/html",
    "hxx": "text/x-c++hdr",
    "ica": "application/x-ica",
    "ice": "x-conference/x-cooltalk",
    "ico": "image/x-icon",
    "ics": "text/calendar",
    "icz": "text/calendar",
    "ief": "image/ief",
    "igs": "model/iges",
    "iges": "model/iges",
    "iii": "application/x-iphone",
    "info": "application/x-info",
    "inp": "chemical/x-gamess-input",
    "ins": "application/x-internet-signup",
    "iso": "application/x-iso9660-image",
    "isp": "application/x-internet-signup",
    "istr": "chemical/x-isostar",
    "ist": "chemical/x-isostar",
    "jad": "text/vnd.sun.j2me.app-descriptor",
    "jam": "application/x-jam",
    "jar": "application/java-archive",
    "java": "text/x-java",
    "jdx": "chemical/x-jcamp-dx",
    "dx": "chemical/x-jcamp-dx",
    "jmz": "application/x-jmol",
    "jng": "image/x-jng",
    "jnlp": "application/x-java-jnlp-file",
    "jpe": "image/jpeg",
    "jpeg": "image/jpeg",
    "jpg": "image/jpeg",
    "js": "application/javascript",
    "json": "application/json",
    "kar": "audio/midi",
    "key": "application/pgp-keys",
    "kil": "application/x-killustrator",
    "kin": "chemical/x-kinemage",
    "kml": "application/vnd.google-earth.kml+xml",
    "kmz": "application/vnd.google-earth.kmz",
    "kpr": "application/x-kpresenter",
    "kpt": "application/x-kpresenter",
    "ksp": "application/x-kspread",
    "kwd": "application/x-kword",
    "kwt": "application/x-kword",
    "latex": "application/x-latex",
    "lha": "application/x-lha",
    "lhs": "text/x-literate-haskell",
    "lin": "application/bbolin",
    "lsf": "video/x-la-asf",
    "lsx": "video/x-la-asf",
    "ltx": "text/x-tex",
    "lyx": "application/x-lyx",
    "lzh": "application/x-lzh",
    "lzx": "application/x-lzx",
    "m3g": "application/m3g",
    "m3u": "audio/mpegurl",
    "m3u8": "application/x-mpegURL",
    "m4a": "audio/mpeg",
    "maker": "application/x-maker",
    "man": "application/x-troff-man",
    "manifest": "text/cache-manifest",
    "mcif": "chemical/x-mmcif",
    "mcm": "chemical/x-macmolecule",
    "mdb": "application/msaccess",
    "me": "application/x-troff-me",
    "mesh": "model/mesh",
    "mid": "audio/midi",
    "midi": "audio/midi",
    "mif": "application/x-mif",
    "mm": "application/x-freemind",
    "mmd": "chemical/x-macromodel-input",
    "mmod": "chemical/x-macromodel-input",
    "mmf": "application/vnd.smaf",
    "mml": "text/mathml",
    "mng": "video/x-mng",
    "moc": "text/x-moc",
    "mol": "chemical/x-mdl-molfile",
    "mol2": "chemical/x-mol2",
    "moo": "chemical/x-mopac-out",
    "mop": "chemical/x-mopac-input",
    "mopcrt": "chemical/x-mopac-input",
    "movie": "video/x-sgi-movie",
    "mp2": "audio/mpeg",
    "mp3": "audio/mpeg",
    "mp4": "video/mp4",
    "mpc": "chemical/x-mopac-input",
    "mpe": "video/mpeg",
    "mpeg": "video/mpeg",
    "mpega": "audio/mpeg",
    "mpg": "video/mpeg",
    "mpga": "audio/mpeg",
    "mph": "application/x-comsol",
    "mpv": "video/x-matroska",
    "mkv": "video/x-matroska",
    "ms": "application/x-troff-ms",
    "msh": "model/mesh",
    "msi": "application/x-msi",
    "mvb": "chemical/x-mopac-vib",
    "mxf": "application/mxf",
    "mxu": "video/vnd.mpegurl",
    "nb": "application/mathematica",
    "nbp": "application/mathematica",
    "nc": "application/x-netcdf",
    "nef": "image/x-nikon-nef",
    "nwc": "application/x-nwc",
    "o": "application/x-object",
    "oda": "application/oda",
    "odb": "application/vnd.oasis.opendocument.database",
    "odc": "application/vnd.oasis.opendocument.chart",
    "odf": "application/vnd.oasis.opendocument.formula",
    "odg": "application/vnd.oasis.opendocument.graphics",
    "odi": "application/vnd.oasis.opendocument.image",
    "odm": "application/vnd.oasis.opendocument.text-master",
    "odp": "application/vnd.oasis.opendocument.presentation",
    "ods": "application/vnd.oasis.opendocument.spreadsheet",
    "odt": "application/vnd.oasis.opendocument.text",
    "oga": "audio/ogg",
    "ogg": "audio/ogg",
    "ogv": "video/ogg",
    "ogx": "application/ogg",
    "old": "application/x-trash",
    "one": "application/onenote",
    "onepkg": "application/onenote",
    "onetmp": "application/onenote",
    "onetoc2": "application/onenote",
    "orc": "audio/csound",
    "orf": "image/x-olympus-orf",
    "otg": "application/vnd.oasis.opendocument.graphics-template",
    "oth": "application/vnd.oasis.opendocument.text-web",
    "otp": "application/vnd.oasis.opendocument.presentation-template",
    "ots": "application/vnd.oasis.opendocument.spreadsheet-template",
    "ott": "application/vnd.oasis.opendocument.text-template",
    "oza": "application/x-oz-application",
    "p": "text/x-pascal",
    "pas": "text/x-pascal",
    "p7r": "application/x-pkcs7-certreqresp",
    "pac": "application/x-ns-proxy-autoconfig",
    "pat": "image/x-coreldrawpattern",
    "pbm": "image/x-portable-bitmap",
    "pcap": "application/cap",
    "pcf": "application/x-font",
    "pcx": "image/pcx",
    "pdb": "chemical/x-pdb",
    "ent": "chemical/x-pdb",
    "pdf": "application/pdf",
    "pfa": "application/x-font",
    "pfb": "application/x-font",
    "pgm": "image/x-portable-graymap",
    "pgn": "application/x-chess-pgn",
    "pgp": "application/pgp-signature",
    "php": "application/x-httpd-php",
    "php3": "application/x-httpd-php3",
    "php3p": "application/x-httpd-php3-preprocessed",
    "php4": "application/x-httpd-php4",
    "php5": "application/x-httpd-php5",
    "phps": "application/x-httpd-php-source",
    "pht": "application/x-httpd-php",
    "phtml": "application/x-httpd-php",
    "pk": "application/x-tex-pk",
    "pl": "text/x-perl",
    "pm": "text/x-perl",
    "pls": "audio/x-scpls",
    "png": "image/png",
    "pnm": "image/x-portable-anymap",
    "pot": "text/plain",
    "potm": "application/vnd.ms-powerpoint.template.macroEnabled.12",
    "potx": "application/vnd.openxmlformats-officedocument.presentationml.template",
    "ppam": "application/vnd.ms-powerpoint.addin.macroEnabled.12",
    "ppm": "image/x-portable-pixmap",
    "pps": "application/vnd.ms-powerpoint",
    "ppsm": "application/vnd.ms-powerpoint.slideshow.macroEnabled.12",
    "ppsx": "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
    "ppt": "application/vnd.ms-powerpoint",
    "pptm": "application/vnd.ms-powerpoint.presentation.macroEnabled.12",
    "pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "prf": "application/pics-rules",
    "prt": "chemical/x-ncbi-asn1-ascii",
    "ps": "application/postscript",
    "psd": "image/x-photoshop",
    "py": "text/x-python",
    "pyc": "application/x-python-code",
    "pyo": "application/x-python-code",
    "qgs": "application/x-qgis",
    "qt": "video/quicktime",
    "mov": "video/quicktime",
    "qtl": "application/x-quicktimeplayer",
    "ra": "audio/x-realaudio",
    "ram": "audio/x-pn-realaudio",
    "rar": "application/rar",
    "ras": "image/x-cmu-raster",
    "rb": "application/x-ruby",
    "rd": "chemical/x-mdl-rdfile",
    "rdf": "application/rdf+xml",
    "rdp": "application/x-rdp",
    "rgb": "image/x-rgb",
    "rhtml": "application/x-httpd-eruby",
    "rm": "audio/x-pn-realaudio",
    "roff": "application/x-troff",
    "ros": "chemical/x-rosdal",
    "rpm": "application/x-redhat-package-manager",
    "rss": "application/rss+xml",
    "rtf": "application/rtf",
    "rtx": "text/richtext",
    "rxn": "chemical/x-mdl-rxnfile",
    "scala": "text/x-scala",
    "sci": "application/x-scilab",
    "sce": "application/x-scilab",
    "sco": "audio/csound",
    "scr": "application/x-silverlight",
    "sct": "text/scriptlet",
    "wsc": "text/scriptlet",
    "sd": "chemical/x-mdl-sdfile",
    "sdf": "chemical/x-mdl-sdfile",
    "sd2": "audio/x-sd2",
    "sda": "application/vnd.stardivision.draw",
    "sdc": "application/vnd.stardivision.calc",
    "sdd": "application/vnd.stardivision.impress",
    "sds": "application/vnd.stardivision.chart",
    "sdw": "application/vnd.stardivision.writer",
    "ser": "application/java-serialized-object",
    "sfv": "text/x-sfv",
    "sgf": "application/x-go-sgf",
    "sgl": "application/vnd.stardivision.writer-global",
    "sh": "application/x-sh",
    "shar": "application/x-shar",
    "shp": "application/x-qgis",
    "shtml": "text/html",
    "shx": "application/x-qgis",
    "sid": "audio/prs.sid",
    "sik": "application/x-trash",
    "silo": "model/mesh",
    "sis": "application/vnd.symbian.install",
    "sisx": "x-epoc/x-sisx-app",
    "sit": "application/x-stuffit",
    "sitx": "application/x-stuffit",
    "skd": "application/x-koan",
    "skm": "application/x-koan",
    "skp": "application/x-koan",
    "skt": "application/x-koan",
    "sldm": "application/vnd.ms-powerpoint.slide.macroEnabled.12",
    "sldx": "application/vnd.openxmlformats-officedocument.presentationml.slide",
    "smi": "application/smil",
    "smil": "application/smil",
    "spc": "chemical/x-galactic-spc",
    "spl": "application/futuresplash",
    "spx": "audio/ogg",
    "sql": "application/x-sql",
    "src": "application/x-wais-source",
    "stc": "application/vnd.sun.xml.calc.template",
    "std": "application/vnd.sun.xml.draw.template",
    "sti": "application/vnd.sun.xml.impress.template",
    "stl": "application/sla",
    "stw": "application/vnd.sun.xml.writer.template",
    "sty": "text/x-tex",
    "sv4cpio": "application/x-sv4cpio",
    "sv4crc": "application/x-sv4crc",
    "svg": "image/svg+xml",
    "svgz": "image/svg+xml",
    "sw": "chemical/x-swissprot",
    "swf": "application/x-shockwave-flash",
    "swfl": "application/x-shockwave-flash",
    "sxc": "application/vnd.sun.xml.calc",
    "sxd": "application/vnd.sun.xml.draw",
    "sxg": "application/vnd.sun.xml.writer.global",
    "sxi": "application/vnd.sun.xml.impress",
    "sxm": "application/vnd.sun.xml.math",
    "sxw": "application/vnd.sun.xml.writer",
    "t": "application/x-troff",
    "tar": "application/x-tar",
    "taz": "application/x-gtar-compressed",
    "tcl": "application/x-tcl",
    "tk": "text/x-tcl",
    "tex": "text/x-tex",
    "texinfo": "application/x-texinfo",
    "texi": "application/x-texinfo",
    "text": "text/plain",
    "tgf": "chemical/x-mdl-tgf",
    "tgz": "application/x-gtar-compressed",
    "thmx": "application/vnd.ms-officetheme",
    "tiff": "image/tiff",
    "tif": "image/tiff",
    "tm": "text/texmacs",
    "torrent": "application/x-bittorrent",
    "tr": "application/x-troff",
    "ts": "video/MP2T",
    "tsp": "application/dsptype",
    "tsv": "text/tab-separated-values",
    "txt": "text/plain",
    "udeb": "application/x-debian-package",
    "uls": "text/iuls",
    "ustar": "application/x-ustar",
    "val": "chemical/x-ncbi-asn1-binary",
    "aso": "chemical/x-ncbi-asn1-binary",
    "vcd": "application/x-cdlink",
    "vcf": "text/x-vcard",
    "vcs": "text/x-vcalendar",
    "vmd": "chemical/x-vmd",
    "vms": "chemical/x-vamas-iso14976",
    "vrm": "x-world/x-vrml",
    "vsd": "application/vnd.visio",
    "wad": "application/x-doom",
    "wav": "audio/x-wav",
    "wax": "audio/x-ms-wax",
    "wbmp": "image/vnd.wap.wbmp",
    "wbxml": "application/vnd.wap.wbxml",
    "webm": "video/webm",
    "wk": "application/x-123",
    "wm": "video/x-ms-wm",
    "wma": "audio/x-ms-wma",
    "wmd": "application/x-ms-wmd",
    "wml": "text/vnd.wap.wml",
    "wmlc": "application/vnd.wap.wmlc",
    "wmls": "text/vnd.wap.wmlscript",
    "wmlsc": "application/vnd.wap.wmlscriptc",
    "wmv": "video/x-ms-wmv",
    "wmx": "video/x-ms-wmx",
    "wmz": "application/x-ms-wmz",
    "wp5": "application/vnd.wordperfect5.1",
    "wpd": "application/vnd.wordperfect",
    "wrl": "model/vrml",
    "vrml": "model/vrml",
    "wvx": "video/x-ms-wvx",
    "wz": "application/x-wingz",
    "x3d": "model/x3d+xml",
    "x3db": "model/x3d+binary",
    "x3dv": "model/x3d+vrml",
    "xbm": "image/x-xbitmap",
    "xcf": "application/x-xcf",
    "xht": "application/xhtml+xml",
    "xhtml": "application/xhtml+xml",
    "xlam": "application/vnd.ms-excel.addin.macroEnabled.12",
    "xlb": "application/vnd.ms-excel",
    "xls": "application/vnd.ms-excel",
    "xlsb": "application/vnd.ms-excel.sheet.binary.macroEnabled.12",
    "xlsm": "application/vnd.ms-excel.sheet.macroEnabled.12",
    "xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "xlt": "application/vnd.ms-excel",
    "xltm": "application/vnd.ms-excel.template.macroEnabled.12",
    "xltx": "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
    "xml": "application/xml",
    "xpi": "application/x-xpinstall",
    "xpm": "image/x-xpixmap",
    "xsd": "application/xml",
    "xsl": "application/xml",
    "xspf": "application/xspf+xml",
    "xtel": "chemical/x-xtel",
    "xul": "application/vnd.mozilla.xul+xml",
    "xwd": "image/x-xwindowdump",
    "xyz": "chemical/x-xyz",
    "zip": "application/zip",
    "zmt": "chemical/x-mopac-input"
  };

  /**
   * 
   * @param {ext} extension 
   * @returns {mimeType}
   */
  static Get(extension){
    return this.__extList[extension] ?? null;
  }

}

export default MimeTypeX;